var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg154Bookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.998,431.996c-11.046,0-20,8.954-20,20c0,5.576-1.889,10.268-5.615,13.947c-3.91,3.861-9.583,6.098-15.132,6.054 c-5.475-0.07-9.919-1.935-13.587-5.705L270.333,358.048c-3.765-3.869-8.935-6.052-14.333-6.052s-10.568,2.183-14.333,6.052 L136.335,466.292c-3.641,3.742-8.118,5.608-13.686,5.706c-5.61,0.115-11.257-2.12-15.14-5.936 c-3.655-3.591-5.508-8.206-5.508-13.718V79.999c0-22.056,17.944-40,40-40h227.997c22.056,0,40,17.944,40,40v272.997 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V79.999C449.997,35.888,414.11,0,369.998,0H142.001 C97.889,0,62.002,35.888,62.002,79.999v372.345c0,16.174,6.206,31.179,17.474,42.25C90.77,505.69,106.32,512,122.288,512 c0.355,0,0.711-0.003,1.066-0.009c16.191-0.285,30.592-6.441,41.648-17.804L256,400.673l90.998,93.514 c11.136,11.444,25.572,17.601,41.747,17.806c16.236,0.167,32.215-6.204,43.742-17.588c11.292-11.149,17.51-26.211,17.51-42.409 C449.998,440.95,441.044,431.996,429.998,431.996z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg154Bookmark);
export default __webpack_public_path__ + "static/media/154-bookmark.8f53cd7a01a402728c73cf792ef87a41.svg";
export { ForwardRef as ReactComponent };